import { SurgicalOrderStatus } from 'presentation/shared/components/Timeline/status'

export const surgicalsOrdersStatus = [
  {
    label: 'Pedidos solicitados por pacientes',
    value: SurgicalOrderStatus.ORDER_REGISTERED
  },
  {
    label: 'Revisão',
    value: SurgicalOrderStatus.REVIEW
  },
  {
    label: 'Pré-agendamento',
    value: SurgicalOrderStatus.PRE_SCHEDULE
  },
  {
    label: 'Cotação de OPME',
    value: SurgicalOrderStatus.OPME_QUOTATION
  },
  {
    label: 'Na CRMO',
    value: SurgicalOrderStatus.CRMO
  },
  {
    label: 'No convênio',
    value: SurgicalOrderStatus.HEALTH_INSURANCE_APPROVE
  },
  {
    label: 'Autorizado',
    value: SurgicalOrderStatus.AUTHORIZED
  },
  {
    label: 'Realizado',
    value: SurgicalOrderStatus.CONCLUDED
  },
  {
    label: 'Solicitações de cancelamento',
    value: SurgicalOrderStatus.CANCELLATION_REQUEST
  },
  {
    label: 'Cancelados',
    value: SurgicalOrderStatus.CANCELLED
  },
  {
    label: 'Pendências',
    value: SurgicalOrderStatus.PENDENCY
  },
  {
    label: 'Pedido cadastrado',
    value: SurgicalOrderStatus.ORDER_REGISTERED
  },
  {
    label: 'Pedido agendado',
    value: SurgicalOrderStatus.SCHEDULED
  },
  {
    label: 'Validação CRMO',
    value: SurgicalOrderStatus.CRMO_VALIDATION
  },
  {
    label: 'Aguardando retorno do convênio',
    value: SurgicalOrderStatus.IN_HEALTH_INSURANCE
  },
  {
    label: 'Pedidos agendados autorizados',
    value: SurgicalOrderStatus.SCHEDULED_AUTHORIZED
  },
  {
    label: 'Pedidos não agendados ',
    value: SurgicalOrderStatus.UNSCHEDULED
  },
  {
    label: 'Pedidos agendados não autorizados',
    value: SurgicalOrderStatus.SCHEDULED_NOT_AUTHORIZED
  },
  {
    label: 'Pedidos não agendados autorizados',
    value: SurgicalOrderStatus.UNSCHEDULED_AUTHORIZED
  },
  {
    label: 'Pedidos não agendados não autorizados',
    value: SurgicalOrderStatus.UNSCHEDULED_NOT_AUTHORIZED
  },
  {
    label: 'Pedidos negados',
    value: SurgicalOrderStatus.DENIED
  },
  {
    label: 'Pedidos em reanálise',
    value: SurgicalOrderStatus.REANALYSIS
  },
  {
    label: 'Autorizado com divergência',
    value: SurgicalOrderStatus.PARTIALLY_AUTHORIZED
  },
  {
    label: 'Pedidos em processo de autorização',
    value: SurgicalOrderStatus.IN_AUTHORIZATION_PROCESS
  }
]

export const getSurgicalOrderStatusLabelByEnum = (
  surgeryStatusEnum: string
) => {
  const surgicalOrderStatus = surgicalsOrdersStatus.find(
    (e) => e.value === surgeryStatusEnum
  )
  return surgicalOrderStatus ? surgicalOrderStatus.label : ''
}

export const getSurgicalOrderStatusEnumByLabel = (label: string) => {
  const surgicalOrderStatus = surgicalsOrdersStatus.find(
    (e) => e.label === label
  )
  return surgicalOrderStatus ? surgicalOrderStatus.value : ''
}
